import PropTypes from "prop-types";

import focusElementRefKeys from "@/view/constants/focusElementRefKeys/focusElementRefKeys";
import PollForm from "@/view/PollContainer/PollForm/PollForm.js";
import useFocusManager from "@/view/utils/useFocusManager/useFocusManager";
import usePollContext from "@/view/utils/usePollContext";
import PollBody from "./PollBody";
import {
  pollContainerCss,
  pollEyebrowCss,
  pollHeaderContentCss,
  pollHeaderCss,
  pollTitleCss,
} from "./Poll.style";

const propTypes = {
  closeButton: PropTypes.node,
  editButtonSlot: PropTypes.node,
  eyebrow: PropTypes.string.isRequired,
  footer: PropTypes.node.isRequired,
  isInteractive: PropTypes.bool,
  isValidateFormFieldsActive: PropTypes.bool,
  pollSelectorSlot: PropTypes.node,
  setSelectedValue: PropTypes.func,
  shouldShowCloseButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
  userId: PropTypes.string,
};

const Poll = ({
  closeButton,
  editButtonSlot,
  eyebrow,
  footer,
  isInteractive,
  isValidateFormFieldsActive,
  pollSelectorSlot,
  setSelectedValue,
  shouldShowCloseButton,
  title,
  userId,
}) => {
  const { activePoll, isCreateMode, isEditMode } = usePollContext();
  const { setFocusManagerRef } = useFocusManager();

  return (
    <div
      css={pollContainerCss}
      tabIndex={0}
      ref={(ref) => {
        setFocusManagerRef(ref, focusElementRefKeys.pollContainer);
      }}
    >
      <div css={pollHeaderCss}>
        <div css={pollHeaderContentCss}>
          <div>
            <div css={pollEyebrowCss}>{eyebrow}</div>
            <h2 css={pollTitleCss}>{title}</h2>
          </div>
          {shouldShowCloseButton && closeButton}
        </div>
      </div>
      {isEditMode ? (
        <PollForm
          activePoll={activePoll}
          cancelEditsButtonSlot={editButtonSlot}
          editingYourPollText={pollSelectorSlot}
          isValidateFormFieldsActive={isValidateFormFieldsActive}
          renderBlankForm={isCreateMode}
        />
      ) : (
        <PollBody
          activePoll={activePoll}
          editButtonSlot={editButtonSlot}
          isInteractive={isInteractive}
          pollSelectorSlot={pollSelectorSlot}
          setSelectedValue={setSelectedValue}
          userId={userId}
        />
      )}
      {footer}
    </div>
  );
};

Poll.propTypes = propTypes;

export default Poll;
